import { render } from "./UpcomingView.vue?vue&type=template&id=3daaa592"
import script from "./UpcomingView.vue?vue&type=script&lang=js"
export * from "./UpcomingView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__